export const passwordRegexp =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&£#_-])[A-Za-z\d@$!%*?&£#_-]/
